import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79f4ceff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nonbid_pay" }
const _hoisted_2 = { class: "btn" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("复制付款信息")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_cell_group, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_van_cell, {
          title: "订单编号",
          value: "ADF11233123SDFSDF"
        }),
        _createVNode(_component_van_cell, {
          title: "收款户名",
          value: "深圳中联银融资担保有限公司"
        }),
        _createVNode(_component_van_cell, {
          title: "开户银行",
          value: "上海银行股份有限公司"
        }),
        _createVNode(_component_van_cell, {
          title: "开户支行",
          value: "上海银行股份有限公司深圳分行"
        }),
        _createVNode(_component_van_cell, {
          title: "银行账号",
          value: "6226 0120 1023 656"
        }),
        _createVNode(_component_van_cell, {
          title: "付款金额",
          value: "10000元"
        }),
        _createVNode(_component_van_cell, {
          title: "付款金额(大写)",
          value: "壹万元"
        }),
        _createVNode(_component_van_cell, {
          title: "转账备注",
          value: "SP123123"
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_button, {
        type: "primary",
        onClick: _ctx.copy,
        round: "",
        block: ""
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}